import { Grid, Typography } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';
import { AttributeTag } from '@tassat/symbols';
import moment from 'moment';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface IApiFirmPageHeaderProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
}

const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        width: 'fit-content',
        maxWidth: '440px'
    },
    firmNameContainer: {
        flexBasis: 'auto' as const,
        paddingBottom: '.5rem'
    },
    firmName: {
        fontSize: '1.75rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073'
    },
    lastActivityText: { marginLeft: '1.5rem' },
    statusIcon: {
        marginRight: '.75rem',
        '&:last-child': { marginRight: 0 }
    }
});

export function ApiFirmPageHeaderComponent (props: IApiFirmPageHeaderProps) {
    const {
        classes,
        firm
    } = props;

    //TODO This should not be hard coded
    const lastActivity = moment()
        .subtract(3, 'days');

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            spacing={0}
        >
            <Grid
                className={classes.firmNameContainer}
                item
                xs={12}
            >
                <Typography
                    className={classes.firmName}
                    variant='h3'
                >{firm.Name}
                </Typography>
            </Grid>
            <Grid
                alignItems='center'
                container
                direction='row'
                justifyContent='flex-start'
                spacing={0}
                wrap='nowrap'
            >
                <AttributeTag
                    attribute='API'
                    className={classes.statusIcon}
                />
                <Typography
                    className={classes.lastActivityText}
                    variant='body2'
                >Last Activity {lastActivity.format('MMM DD YY HH:mm')}
                </Typography>
            </Grid>
        </Grid>
    );
}

const ApiFirmPageHeader = withStyles(muiStyles)(ApiFirmPageHeaderComponent);

export { ApiFirmPageHeader };